// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2S4or","balanceDisclaimer":"posDashboard_balanceDisclaimer__1g2Zi"};